/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import isNil from 'lodash/isNil';
import { CalendarDate, endOfMonth, today } from '@internationalized/date';
import { Durations } from '../constants';
import { getDivisionFromPeriods, parseDate } from './date_time_utils';

export const getDuration = (duration = '') => Durations[duration.replace(/,.*/, '')];
export const getDurationOptions = (duration = '') =>
    duration.replace(/^.*?,/, '').split(',');
export const durationLength = (duration = '') => {
    const durationValue = getDuration(duration);
    if (isNil(durationValue)) {
        return 'Not Valid';
    }
    return durationValue.validLength;
};

export const validToDate = (startDate, passType) => {
    const startDateCalendar = startDate ? parseDate(startDate) : today();
    const duration = getDuration(passType.duration);
    const durationOptions = getDurationOptions(passType.duration);
    const division = getDivisionFromPeriods(passType.periods, startDateCalendar);

    const addN =
        duration.days === 365
            ? 1
            : passType.duration === '6-month'
              ? duration.days / 30
              : duration.days > 0
                ? duration.days - 1
                : duration.days; // days = 1, means same day. days = 3, means today + other 2 days... and so on
    const addUnit =
        duration.days === 365
            ? 'years'
            : passType.duration === '6-month'
              ? 'months'
              : 'days';
    const endDate = startDateCalendar.add({ [addUnit]: addN });

    if (!duration.endEndOfMonth) {
        if (
            division?.ends_at &&
            (durationOptions.includes('season') || durationOptions.includes('seasonal'))
        ) {
            return parseDate(`${today().year}-${division.ends_at}`);
        }
        return endDate;
    }
    return endOfMonth(endDate);
};
